import { call, put, select } from 'redux-saga/effects';
import getPoliciesActions from 'redux/actions/getPoliciesActions';
import { getSynergySessionToken } from 'utils/sagas-utils';
import { partnerSelector, selectTenantId } from 'redux/selectors/config';
import { caseReferenceSelector } from 'redux/selectors/caseStatus';
import getPoliciesApi from 'api/getPolicies';
import applicationSpinnerActions from 'redux/actions/applicationSpinnerActions';

const { startLoad, stopLoad } = applicationSpinnerActions;

const isSuccess = (statusCode: any) => statusCode === 200;

export function* getPolicies() {
  try {
    yield put(startLoad({}));
    const caseId: string = yield select(caseReferenceSelector);
    const partner: string = yield select(partnerSelector);
    const tenantId: string = yield select(selectTenantId);
    const token: string = yield getSynergySessionToken();
    const params = { caseId, tenantId, moveVersion: 'move-v3', partner, token };

    const { result, status } = yield call(getPoliciesApi, params);
    if (!isSuccess(status) || !result.productId) {
      throw new Error();
    }
    yield put(getPoliciesActions.getPoliciesSuccess(result));
  } catch (error) {
    console.error('Error while fetching getPolicies', error);
    yield put(getPoliciesActions.getPoliciesFail());
  } finally {
    yield put(stopLoad({}));
  }
}
